export interface UserUuidResponse {
    uuid: string;
}

export interface AuthTokenResponse {
    auth_token?: string;
    detail?: AuthTokenDetails;
}

export const enum AuthTokenDetails {
    Auth0AccExists = "User already has auth0 account",
}

export interface PurchaseProductData {
    uuid?: string | null;
    ident?: string;
    featureName: string | null; // if it's empty product send null
}

export type ShareVideoResponse = {
    date: Date;
    environment: string;
    name: string;
    video_url: string;
};

export interface TestVariantResponse {
    sampled_key: string;
    sampled_score: number;
    sampled_values: {
        [key: string]: number;
    };
}
